import React, { useState } from "react";

import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import addToCartRequest from "../../Pricing/AddToCart/request";

interface Props {
  product: PricingProduct;
  outletId: number;
  itemInCart: boolean;
  onAddToCart: () => void;
}

const OutletAddToCart = ({
  product,
  outletId,
  itemInCart,
  onAddToCart,
}: Props) => {
  const [errorMessage, setErrorMessage] = useState("");

  const outletAddToCart = async (event: React.MouseEvent) => {
    event.preventDefault();

    await addToCartRequest({
      product: {
        ...product,
        price: product.price.price,
        itemNumber: product.originalId,
        outletId,
      },
      quantity: 1,
      autoReorderInterval: "0",
      gtmAtcProps: { source: "outlet product detail" },
    }).then(
      () => {
        onAddToCart?.();
      },
      () => {
        setErrorMessage("There was an error adding this item to your cart.");
      },
    );
  };

  return (
    <div className="add-to-cart" data-testid="outlet-add-to-cart">
      <div className="btn-container special-quantity">
        {itemInCart ? (
          <span
            data-testid="outlet-disabled-atc"
            className="btn btn-ui btn-block btn-large disabled"
          >
            Already in your cart
          </span>
        ) : (
          <form action="/viewcart.cfm" method="post">
            <input type="hidden" name="from" value="add" />
            <input type="hidden" name="price" value={product.price.price} />
            <input
              type="hidden"
              name="feed_identifier"
              value={product.feedIdentifier}
            />
            <input type="hidden" name="item_number" value="OUTLET" />
            <input
              type="hidden"
              name="description"
              value={`Outlet Item #${outletId} (${product.itemNumber.toUpperCase()})`}
            />
            <input type="hidden" name="qty" value={1} />
            <input
              type="submit"
              id="buyButton"
              className="btn btn-cart btn-large"
              value="Add to Cart"
              onClick={outletAddToCart}
            />
          </form>
        )}
      </div>
      <p className="messages">{errorMessage}</p>
    </div>
  );
};

export default OutletAddToCart;
